import { GridActionsCellItem } from "@mui/x-data-grid";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, Icon } from "@mui/material";

export default function LGCrudViewMode({
  id,
  onEdit,
  onDelete,
  onDetail,
  onDownload,
  onPrint,
  onVisualize,
}) {
  return [
    onDetail && (
      <Button
        key={`detail-${id}`}
        variant="contained"
        size="small"
        onClick={(event) => onDetail(event, id)}
        sx={{ my: 2 }}
      >
        Ver mas
      </Button>
    ),
    onDownload && (
      <GridActionsCellItem
        key={`download-${id}`}
        icon={<Icon>download</Icon>}
        label="Descargar"
        className="textPrimary"
        onClick={() => onDownload(id)}
        color="inherit"
      />
    ),
    onPrint && (
      <GridActionsCellItem
        key={`print-${id}`}
        icon={<PrintIcon />}
        label="Imprimir"
        className="textPrimary"
        onClick={() => onPrint(id)}
        color="inherit"
      />
    ),
    onVisualize && (
      <GridActionsCellItem
        key={`visualize-${id}`}
        icon={<VisibilityIcon />}
        label="Visualizar"
        className="textPrimary"
        onClick={() => onVisualize(id)}
        color="inherit"
      />
    ),
    onEdit && (
      <GridActionsCellItem
        key={`edit-${id}`}
        icon={<EditIcon />}
        label="Editar"
        className="textPrimary"
        onClick={() => onEdit(id)}
        color="inherit"
      />
    ),
    onDelete && (
      <GridActionsCellItem
        key={`delete-${id}`}
        icon={<DeleteIcon />}
        label="Eliminar"
        onClick={() => onDelete(id)}
        sx={{ color: "error.main" }}
      />
    ),
  ].filter(Boolean);
}
